// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2buSP","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__xnT2k"};